










import '@/plugins/ios-viewport-size.client'
import Vue from 'vue'
import Layout from '@/layouts/paramount-layout.vue'
export default Vue.extend({
  components: { Layout },
})
